import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import Notiflix from 'notiflix';

@Component({
  selector: 'app-contact',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './contact.html',
  styleUrl: './contact.css'
})
export class ContactComponent {
  spotlightGradient = 'none';

  form = {
    name: '',
    email: '',
    phoneNumber: '',
    message: '',
    company: '',
    unitType: '',
  };

  constructor(private http: HttpClient) {}

  onMouseMove(event: MouseEvent) {
    const rect = (event.currentTarget as HTMLElement).getBoundingClientRect();
    const x = ((event.clientX - rect.left) / rect.width) * 100;
    const y = ((event.clientY - rect.top) / rect.height) * 100;
    this.spotlightGradient = `radial-gradient(circle 520px at ${x}% ${y}%, rgba(201,169,110,0.13) 0%, transparent 70%)`;
  }

  onSubmit() {
    if (!this.form.name || !this.form.email) {
      Notiflix.Notify.warning('Please fill in your name and email address.', {
        timeout: 4000,
        position: 'right-top',
        cssAnimationStyle: 'fade',
      });
      return;
    }

    Notiflix.Loading.circle('Sending...');

    const payload = {
      recipients: ['laban@fameve.com', 'partner@karimcgvisuals.com', 'sales@acacia.ke'],
      data: { ...this.form, website: 'acacia' },
    };

    this.http.post('https://www.blinkstudio.co.ke/send-test-email', payload).subscribe({
      next: () => {
        Notiflix.Loading.remove();
        Notiflix.Notify.success('Thank you. Our team will be in touch shortly.', {
          timeout: 5000,
          position: 'right-top',
          cssAnimationStyle: 'fade',
          success: { background: '#3b2e1a', textColor: '#e8d5a3', notiflixIconColor: '#c9a96e' }
        });
        this.form = { name: '', email: '', phoneNumber: '', message: '', company: '', unitType: '' };
      },
      error: () => {
        Notiflix.Loading.remove();
        Notiflix.Notify.failure('Something went wrong. Please try again.', {
          timeout: 4000,
          position: 'right-top',
          cssAnimationStyle: 'fade',
        });
      },
    });
  }
}
